import React from "react";
import Chip from "@material-ui/core/Chip";
import get from "lodash/get";
import { useRecordContext } from "react-admin";
import { isEmpty, upperCase } from "lodash";

interface IStatusField {
  label?: string;
  record?: any;
  source: string;
}

export const translateStatus = (status: string): string => {
  if (status) {
    if (status === "ready_to_approve") {
      status = "ready_to_approve_by_head_of_school";
    }

    return upperCase(status);
  }
  // make capital to all status
};

const getColor = (text: string): string => {
  if (text) {
    switch (text) {
      case "active":
      case "ready":
      case "completed":
      case "new":
      case "paid":
      case "success":
      case "accepted":
        return "#4caf50";

      case "inactive":
      case "cancel":
      case "cancelled":
      case "failed":
      case "declined":
      case "rejected":
        return "#f44336";

      case "pending":
      case "issued":
      case "unposted":
      case "bus_late":
        return "#ff9800";

      case "graduated":
      case "ready_to_approve":
      case "bus_on_time":
        return "#285F96";

      case "started":
      case "approved":
      case "posted":
        return "#1976d2";

      case "ended":
      case "force_ended":
      case "ended_by_admin":
      case "draft":
        return "#7c4dff";

      default:
        return "#9e9e9e";
    }
  }
};

const StatusField = ({ label, record = {}, source }: IStatusField) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;

  const status = get(records, source);
  const translated = translateStatus(status);
  const color = getColor(status);

  return (
    <div>
      <Chip
        label={translated}
        style={{ backgroundColor: `${color}`, color: "#FFF" }}
      />
    </div>
  );
};

export default StatusField;
